<script>
   /**************************************************************/
   /* Svelte component for AcceptancePlot settings               */
   /**************************************************************/

   import Container from '../../../shared/controls/Container.svelte';
   import Select from '../../../shared/controls/Select.svelte';

   export let params;
   export let res;

   let isAlt = false;
   let scope = 'objects';
   let transType = 'no';
   let showLabels = 'hide';
   let resID = res ? Object.keys(res)[0] : '';

   $: params = {
      isAlt,
      scope,
      transType,
      showLabels,
      resID
   }
</script>

{#if res  }
<Container label="">
   <p class="title">Acceptance plot</p>
</Container>
{#if Object.keys(res).length > 1 }
<Container label='Results:'>
   <Select id='resType' bind:value={resID} options={Object.keys(res)} />
</Container>
{/if}
<Container label='Transform:'>
   <Select id='limType' bind:value={transType} options={['no', 'log']} />
</Container>
<Container label='Labels:'>
   <Select id='showLabels' bind:value={showLabels} options={['hide', 'show']} />
</Container>
{/if}

